import { RouteConfig } from 'vue-router'

const Index = () => import('../activity/sports-card/Index.vue')

export const indexRoute: RouteConfig = {
  path: '/activity/sports-card',
  name: 'activity_sports_card',
  component: Index,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '西游幻境 卡牌奇缘',
  },
}

export default [indexRoute]
